/**
 * Created by mykurisu on 2017/6/8.
 */
import React,{Component} from 'react'
import '../../styles/component.css';


class WKCopyright extends Component {
    static defaultProps = {
        isLink: true
    };

    render (){
        return (
            <div className="pagebottomtext">
                <span>
                    十方教育提供技术支持
                </span>
                {this.props.isLink &&
                <span>
                    <a href={"/complain/" + this.props.type + "/" + this.props.id}>投诉</a>
                </span>
                }
            </div>
        )
    }
}

export default WKCopyright


// WEBPACK FOOTER //
// ./src/components/wk/WKCopyright.js